import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { initAudio, playSound } from "./utils/audio";
import Snowfall from "react-snowfall";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import store from "./redux/store";
import App from "./App";

import "./index.css";

console.disableRedBox = true;

/**
 * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
 * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
const msalInstance = new PublicClientApplication(msalConfig);

// Default to using the first account if no account is active on page load
if (
  !msalInstance.getActiveAccount() &&
  msalInstance.getAllAccounts().length > 0
) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

// Listen for sign-in event and set active account
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account;
    msalInstance.setActiveAccount(account);
  }
});

const container = document.getElementById("root");
const root = createRoot(container);
initAudio();

function ChristmasTime() {
  const today = new Date();

  // Start Date -> 8 December
  const start = new Date();
  start.setMonth(11);
  start.setDate(8);

  // End Date -> 6 January
  const end = new Date();
  end.setFullYear(today.getFullYear() + 1);
  end.setMonth(0);
  end.setDate(6);

  const isChristmasTime = today >= start && today <= end;

  if (isChristmasTime) {
    setInterval(() => playSound("bells"), 1000 * 60 * 5);
    return (
      <>
        {/* <img alt="Santa" src={`${process.env.PUBLIC_URL}/santa.png`} className="santa" /> */}
        <Snowfall
          style={{
            zIndex: "-1",
            opacity: 0.5
          }}
        />
      </>
    );
  }

  return null;
}

// React.StrictMode
root.render(
  <>
    <Provider store={store}>
      <ChristmasTime />

      {/* <React.StrictMode> */}
      <App instance={msalInstance} />
      {/* </React.StrictMode> */}
    </Provider>
  </>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();

//reportWebVitals(console.log);
